import { Action } from '@ngrx/store';

export enum FollowDetailPageActionTypes {
  SelectProducts = '[FollowDetailPage] Select products',
  SetFilter = '[FollowDetailPage] Set Filter',
  UpdateProductCountry = '[FollowDetailPage] Update size break',
  UpdateProductCountrySuccess = '[FollowDetailPage] Update size break success',
  UpdateProductCountryFail = '[FollowDetailPage] Update size break fail',

  ResetData = '[FollowDetailPage] Reset data'
}

export class SelectProducts implements Action {
  readonly type = FollowDetailPageActionTypes.SelectProducts;
  constructor(public ids: number[]) {}
}

export class SetFilter implements Action {
  readonly type = FollowDetailPageActionTypes.SetFilter;
  constructor(public filter: string) {}
}

export class UpdateProductCountry implements Action {
  readonly type = FollowDetailPageActionTypes.UpdateProductCountry;
  constructor(public data: any) {}
}

export class UpdateProductCountryFail implements Action {
  readonly type = FollowDetailPageActionTypes.UpdateProductCountryFail;
  constructor(public error: any) {}
}

export class UpdateProductCountrySuccess implements Action {
  readonly type = FollowDetailPageActionTypes.UpdateProductCountrySuccess;
  constructor(public data: any) {}
}

export class ResetData implements Action {
  readonly type = FollowDetailPageActionTypes.ResetData;
  constructor(public reset: boolean) {}
}

export type FollowDetailPageActionsUnion =
  | SetFilter
  | SelectProducts
  | UpdateProductCountry
  | UpdateProductCountrySuccess
  | UpdateProductCountryFail
  | ResetData;
